// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pk1m","comment":"styles_comment__1R6ac"};